import { IconButton } from "@mui/material";
import styled from "styled-components";

export const CircularIconButton = styled(IconButton)`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background 0.2s ease;

  &:hover {
    background-color: #e5e7eb;
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;
